<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-政策  协议
  -->
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="隐私政策" name="policy">
      </el-tab-pane>
      <el-tab-pane label="用户协议" name="agree">
      </el-tab-pane>
    </el-tabs>
    <!--隐私政策-->
    <Agree v-if="activeName=='user'" :message_to="10"></Agree>
    <!--用户协议-->
    <Policy v-if="activeName=='shop'" :message_to="20"></Policy>
  </div>
</template>
<script>
import Agree from "./part/agree.vue";
import Policy from "./part/policy.vue";
export default {
  components: {
    Agree,
    Policy
  },
  data() {
    return {
      /*参数*/
      message_to: 10,
      /*当前选中*/
      activeName: "policy"
    };
  },
  created() {
    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/views/setting/protocol/index.vue